import { palette } from '@shipium-corp/shipium-ui-theme';
import { createUseStyles } from 'react-jss';

export const filterTableData = (tableData: any[], filterText: string) => {
  const cleansedText = filterText?.toUpperCase()?.trim() ?? '';
  return tableData.filter((obj) => {
    return !!Object.values(obj).find((value: any) => {
      if (Array.isArray(value)) {
        return value?.find((text) => String(text)?.toUpperCase().trim() === cleansedText);
      }
      return typeof value == 'string' && value.trim().toUpperCase().indexOf(cleansedText) > -1;
    });
  });
};

export const useAssetTableStyles = createUseStyles({
  addButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    margin: '0 0 14px 0',
  },
  addButton: {
    backgroundColor: palette.Fuschia.normal,
    borderColor: palette.Fuschia.normal,
    transition: '0.3s',
    '&:hover': {
      backgroundColor: palette.Fuschia.light,
      borderColor: palette.Fuschia.light,
    },
    marginRight: '14px',
  },
});

export const tableActionConvertToIconName = (val: string) => {
  switch (val) {
    case 'Edit':
      return 'EditOutlined';
    case 'Edit Carrier Account':
      return 'EditOutlined';
    case 'Edit Label Augmentations':
      return 'EditOutlined';
    case 'Edit a Fulfillment Context':
      return 'EditOutlined';
    case 'Edit Schedule Entry':
      return 'EditOutlined';
    case 'Delete':
      return 'DeleteOutlined';
    case 'Delete Carrier Schedule details':
      return 'DeleteOutlined';
    case 'Delete Schedule Entry':
      return 'DeleteOutlined';
    case 'Detail':
      return 'FileSearchOutlined';
    default:
      return 'FolderOutlined';
  }
};
